<div class="container">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12" style="padding-top: 10px;">
      <div class="panel panel-default" id="panel4" style="margin-bottom: 0px !important;">
        <div class="panel-heading">
          <h4 class="panel-title">
            <a>
              <b>{{LabelName}}</b>
            </a>
          </h4>
        </div>
      </div>
      <div class="row" id="divTop" style="margin-bottom: 10px;">
        <div class="col-md-12 col-lg-12 col-sm-12">
          <div class="col-md-9 col-xs-9">
            <div id="ButtonsTab">
              <button id="btnGetResult" type="button" title="Get Result" class="btn btn-primary"
                      (click)="GetSearchResult();">
                <span class="hidden-xs">Get Result</span>
              </button>
              <button id="btnReset" type="button" title="Reset" class="btn btn-primary" (click)="ResetResult();">
                <span>Reset</span>
              </button>
              <button id="btnExport" type="button" title="Export" (click)="ExportToExcel();" class="btn btn-primary">
                <span class="hidden-xs">Export</span>
              </button>
              <button id="btnExit" type="button" title="Exit" class="btn btn-primary" (click)="onExit();">
                <span class="hidden-xs">Exit</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="ErrorMessage.length > 0">
        <div class="col-md-12">
          <div style="font-size:small;">
            <img src="assets/img/error_icon.gif" /><span class="text-error" style="font-weight:bold;color:red;">
              The
              following errors were encountered on the page.
            </span>
          </div>
          <div id="divMainError" class="text-error"
               style="padding-top:0px; margin-bottom:10px;margin-left:25px; font-size:small; color:red">
            <span style="display:list-item" *ngFor="let item of ErrorMessage">{{item.message}}</span>
          </div>
        </div>
      </div>
      <!-- Search Criteria New-->
      <div class="accordion">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
              <b>Search Criteria &nbsp;&nbsp; (Click (+/-) to view the Search Parameters)</b>
            </button>
          </h2>
          <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="row pb-2">
                    <div class="col-sm-4" style="padding-top:7px;">Creation Date(From)</div>
                    <div class="col-md-8 col-sm-8">
                      <div class="form-group">
                        <div class="input-group date">
                          <input matInput class ="form-control" style="width: 250px; font-size: 14px;" [matDatepicker]="CreationDateFrom"
                                                 placeholder="Choose a date" [(ngModel)]="FTERecordsList.CreatedOnFrom" disabled
                                                autocomplete="off" (dateChange)="ChangeDateFormat($event,'CreatedOnFrom')">
                            <mat-datepicker-toggle matSuffix [for] ="CreationDateFrom">
                              </mat-datepicker-toggle>
                              <mat-datepicker #CreationDateFrom disabled="false"></mat-datepicker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row pb-2">
                    <div class="col-sm-4" style="padding-top:7px;">
                      Creation Date(To)
                    </div>
                    <div class="col-md-8 col-sm-8">
                      <div class="form-group">
                        <div class="input-group date">
                          <input matInput class ="form-control" style="width: 250px; font-size: 14px;" [matDatepicker]="CreationDateTo" placeholder="Choose a date" [(ngModel)]="FTERecordsList.CreatedOnTo" disabled autocomplete="off" (dateChange)="ChangeDateFormat($event,'CreatedOnTo')">
                          <mat-datepicker-toggle matSuffix [for] ="CreationDateTo"></mat-datepicker-toggle>
                          <mat-datepicker #CreationDateTo disabled="false"></mat-datepicker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="ParamID == 3">
                <div class="col-md-6">
                  <div class="row pb-2">
                    <div class="col-sm-4">
                      <span class="" style="padding-top:7px;">Counsellor Sub. Date(From)</span>
                    </div>
                    <div class="col-md-8 col-sm-8">
                      <div class="form-group">
                        <div class="input-group date">
                          <input matInput class ="form-control" style="width: 250px; font-size: 14px;" [matDatepicker]="CouncelorSubFrom"
                                                 placeholder="Choose a date" [(ngModel)]="FTERecordsList.CouncelorActionOnFrom" disabled
                                                autocomplete="off" (dateChange)="ChangeDateFormat($event,'CouncelorActionOnFrom')">
                            <mat-datepicker-toggle matSuffix [for] ="CouncelorSubFrom">
                              </mat-datepicker-toggle>
                              <mat-datepicker #CouncelorSubFrom disabled="false"></mat-datepicker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row pb-2">
                    <div class="col-sm-4" style="padding-top:7px;">Counsellor Sub. Date(To)</div>
                    <div class="col-md-8 col-sm-8">
                      <div class="form-group">
                        <div class="input-group date">
                          <input matInput class ="form-control" style="width: 250px; font-size: 14px;" [matDatepicker]="CouncelorSubTo"
                                                 placeholder="Choose a date" [(ngModel)]="FTERecordsList.CouncelorActionOnTo" disabled
                                                autocomplete="off" (dateChange)="ChangeDateFormat($event,'CouncelorActionOnTo')">
                            <mat-datepicker-toggle matSuffix [for] ="CouncelorSubTo">
                              </mat-datepicker-toggle>
                              <mat-datepicker #CouncelorSubTo disabled="false"></mat-datepicker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="ParamID == 3">
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4" style="padding-top:7px;">Partner's Action Date(From)</span>
                    <div class="col-md-8 col-sm-8">
                      <div class="form-group">
                        <div class="input-group date">
                          <input matInput class ="form-control" style="width: 250px; font-size: 14px;" [matDatepicker]="PartnerActionDateFrom"
                                                 placeholder="Choose a date" [(ngModel)]="FTERecordsList.PartnerActionOnFrom" disabled
                                                autocomplete="off" (dateChange)="ChangeDateFormat($event,'PartnerActionOnFrom')">
                            <mat-datepicker-toggle matSuffix [for] ="PartnerActionDateFrom">
                              </mat-datepicker-toggle>
                              <mat-datepicker #PartnerActionDateFrom disabled="false"></mat-datepicker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4" style="padding-top:7px;">Partner's Action Date(To)</span>
                    <div class="col-md-8 col-sm-8">
                      <div class="form-group">
                        <div class="input-group date">
                          <input matInput class ="form-control" style="width: 250px; font-size: 14px;" [matDatepicker]="PartnerActionDateTo"
                                                 placeholder="Choose a date" [(ngModel)]="FTERecordsList.PartnerActionOnTo" disabled
                                                autocomplete="off" (dateChange)="ChangeDateFormat($event,'PartnerActionOnTo')">
                            <mat-datepicker-toggle matSuffix [for] ="PartnerActionDateFrom">
                              </mat-datepicker-toggle>
                              <mat-datepicker #PartnerActionDateTo disabled="false"></mat-datepicker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row pb-2">
                    <div class="col-sm-4" style="padding-top:7px;">Contract End Date(From)</div>
                    <div class="col-md-8 col-sm-8">
                      <div class="form-group">
                        <div class="input-group date">
                          <input matInput class ="form-control" style="width: 250px; font-size: 14px;" [matDatepicker]="EmploymentEndDateFrom"
                                                 placeholder="Choose a date" [(ngModel)]="FTERecordsList.EmpContractEndDateFrom" disabled
                                                autocomplete="off" (dateChange)="ChangeDateFormat($event,'EmpContractEndDateFrom')">
                            <mat-datepicker-toggle matSuffix [for] ="EmploymentEndDateFrom">
                              </mat-datepicker-toggle>
                              <mat-datepicker #EmploymentEndDateFrom disabled="false"></mat-datepicker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4" style="padding-top:7px;">Contract End Date(To)</span>
                    <div class="col-md-8 col-sm-8">
                      <div class="form-group">
                        <div class="input-group date">
                          <input matInput class ="form-control" style="width: 250px; font-size: 14px;" [matDatepicker]="EmploymentEndDateTo"
                                                 placeholder="Choose a date" [(ngModel)]="FTERecordsList.EmpContractEndDateTo" disabled
                                                autocomplete="off" (dateChange)="ChangeDateFormat($event,'EmpContractEndDateTo')">
                            <mat-datepicker-toggle matSuffix [for] ="EmploymentEndDateTo">
                              </mat-datepicker-toggle>
                              <mat-datepicker #EmploymentEndDateTo disabled="false"></mat-datepicker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4" style="padding-top:7px;">Last Increment Date(From)</span>
                    <div class="col-md-8 col-sm-8">
                      <div class="form-group">
                        <div class="input-group date">
                          <input matInput class ="form-control" style="width: 250px; font-size: 14px;" [matDatepicker]="LastIncrementDateFrom"
                                                 placeholder="Choose a date" [(ngModel)]="FTERecordsList.LastIncrementDateFrom" disabled
                                                autocomplete="off" (dateChange)="ChangeDateFormat($event,'LastIncrementDateFrom')">
                            <mat-datepicker-toggle matSuffix [for] ="LastIncrementDateFrom">
                              </mat-datepicker-toggle>
                              <mat-datepicker #LastIncrementDateFrom disabled="false"></mat-datepicker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4" style="padding-top:7px;">Last Increment Date(To)</span>
                    <div class="col-md-8 col-sm-8">
                      <div class="form-group">
                        <div class="input-group date">
                          <input matInput class ="form-control" style="width: 250px; font-size: 14px;" [matDatepicker]="LastIncrementDateTo"
                                                 placeholder="Choose a date" [(ngModel)]="FTERecordsList.LastIncrementDateTo" disabled
                                                autocomplete="off" (dateChange)="ChangeDateFormat($event,'LastIncrementDateTo')">
                            <mat-datepicker-toggle matSuffix [for] ="LastIncrementDateTo">
                              </mat-datepicker-toggle>
                              <mat-datepicker #LastIncrementDateTo disabled="false"></mat-datepicker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4" style="padding-top: 7px;">Record ID</span>
                    <div class="col-sm-8">
                      <div class="form-group">
                        <input type="text" id="txtRecordID" maxlength="20" name="txtRecordID" class="form-control"
                               [(ngModel)]="FTERecordsList.FTEID" autocomplete="off" (keypress)="blockSpecialChar($event)"
                               #txtRecordID="ngModel" />
                        <div *ngIf="((txtRecordID.dirty || txtRecordID.touched) && txtRecordID.invalid)"
                             class="text-danger">Invalid input.</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4" style="padding-top:7px;">Location</span>
                    <div class="col-md-8 col-sm-8">
                      <div class="form-group">
                        <select id="ddlLocation" class="form-control" [(ngModel)]="FTERecordsList.EmpLocationText">
                          <option value="0">Select</option>
                          <option *ngFor="let item of LocationList" value={{item.Location}}>{{item.Location}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4">Employee Name</span>
                    <div class="col-sm-8">
                      <div class="form-group">
                        <p-autoComplete [(ngModel)]="EmployeeList.Employee" [suggestions]="filteredEmployeeSingle" autocomplete="off"
                                        (completeMethod)="GetEmpSearch($event,false)" field="EmpFullName" [size]="30"
                                        placeholder="Enter Name for Search" [minLength]="3" aria-describedby="basic-addon3"
                                        name="Employee" (onClear)="OnClearSendUser()" (onSelect)="SetSelectedEmpGPN($event)"
                                        [forceSelection]="true" [style]="{'width':'100%', 'height':'40px','font-size': '14px'}" [inputStyle]="{'width':'100%'}"></p-autoComplete>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4">Email ID</span>
                    <div class="col-sm-8">
                      <div class="form-group">
                        <input type="text" id="txtEmailID" name="txtEmailID" maxlength="100" class="form-control"
                               [(ngModel)]="FTERecordsList.EmpEmail" autocomplete="off" #txtEmailID="ngModel" />
                        <div *ngIf="((txtEmailID.dirty || txtEmailID.touched) && txtEmailID.invalid)"
                             class="text-danger">Invalid input.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4" style="padding-top:7px;">Service Line</span>
                    <div class="col-md-8 col-sm-8">
                      <div class="form-group">
                        <select id="ddlServiceLine" class="form-control" [(ngModel)]="FTERecordsList.ServiceLineText">
                          <option value="">Select</option>
                          <option *ngFor="let item of ServiceLineList" value={{item.SL}}>{{item.SL}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4">Counsellor</span>
                    <div class="col-sm-8">
                      <div class="form-group">
                        <input type="text" id="txtCouncelor" name="txtCouncelor" maxlength="100" class="form-control"
                               [(ngModel)]="FTERecordsList.CouncelorName" autocomplete="off" (keypress)="blockSpecialChar($event)"
                               #txtCouncelor="ngModel" pattern="^[a-zA-Z0-9\s]*$">
                        <div *ngIf="((txtCouncelor.dirty || txtCouncelor.touched) && txtCouncelor.invalid)"
                             class="text-danger">Invalid input.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4" style="padding-top: 7px;">Title</span>
                    <div class="col-sm-8">
                      <div class="form-group">
                        <select id="ddltitle" class="form-control" [(ngModel)]="FTERecordsList.EmpTitle">
                          <option value="">Select</option>
                          <option *ngFor="let item of TitleList" value={{item.Emptitle}}>{{item.Emptitle}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4" style="padding-top:7px;">Manager</span>
                    <div class="col-md-8 col-sm-8">
                      <div class="form-group">
                        <p-autoComplete [(ngModel)]="ManagerList.Manager" [suggestions]="filteredManagerSingle" autocomplete="off"
                                        (completeMethod)="GetManagerSearch($event)" field="EmpFullName" [size]="30"
                                        placeholder="Enter Manager Name for Search" [minLength]="3" aria-describedby="basic-addon3"
                                        name="Manager" (onClear)="OnClearManager()" (onSelect)="SetSelectedManager($event)"
                                        [forceSelection]="true" [style]="{'width':'100%', 'height':'40px', 'font-size': '14px'}" [inputStyle]="{'width':'100%'}"></p-autoComplete>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4" style="padding-top: 7px;">Partner</span>
                    <div class="col-sm-8">
                      <div class="form-group">
                        <p-autoComplete [(ngModel)]="PartnerList.Partner" [suggestions]="filteredPartnerSingle" autocomplete="off"
                                        (completeMethod)="GetPartnerSearch($event)" field="EmpFullName" [size]="30"
                                        placeholder="Enter Partner Name for Search" [minLength]="3" aria-describedby="basic-addon3"
                                        name="Partner" (onClear)="OnClearPartner()" (onSelect)="SetSelectedPartner($event)"
                                        [forceSelection]="true" [style]="{'width':'100%', 'height':'40px','font-size': '14px'}" [inputStyle]="{'width':'100%'}"></p-autoComplete>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6" *ngIf="ParamID == 4">
                  <div class="row pb-2">
                    <span class="col-sm-4" style="padding-top: 7px;">Status</span>
                    <div class="col-sm-8">
                      <div class="form-group">
                        <select id="ddltitle" class="form-control" [(ngModel)]="FTERecordsList.RequestStatusID">
                          <option value="">Select</option>
                          <option *ngFor="let item of StatusList" value={{item.KeyWordValue}}>{{item.KeyWordText}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--Added by Utkarsh for CR_2311_0209-->
              <div class="row">
                <div class="col-md-6">
                  <div class="row pb-2">
                    <span class="col-sm-4">Employee GPN</span>
                    <div class="col-sm-8">
                      <div class="form-group">
                        <p-autoComplete [(ngModel)]="EmployeeList.EmployeeGPN" [suggestions]="filteredEmployeeSingle" autocomplete="off"
                                        (completeMethod)="GetEmpSearch($event,true)" field="EmpGPNWithEmail" [size]="30"
                                        placeholder="Enter GPN to Search" [minLength]="3" aria-describedby="basic-addon3"
                                        name="EmployeeGPN" (onClear)="OnClearSendUser2()" (onSelect)="SetSelectedEmpGPN2($event)"
                                        [forceSelection]="true" [style]="{'width':'100%', 'height':'40px','font-size': '14px'}" [inputStyle]="{'width':'100%'}"></p-autoComplete>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="panel-group">
            <div class="panel panel-default" id="panel1">
              <div class="panel-heading d-flex align-items-center justify-content-between">
                <h4 class="panel-title">
                  <a>
                    <b>View Records</b>
                  </a>
                </h4>
                <div *ngIf="ParamID == 5">
                  <h5 class="panel-title">

                    <button id="btnUploadRec" type="button" title="Upload Records" class="upload-btn btn btn-primary text-end"
                            (click)="OpenUploadDialog();">
                      <span class="d-none d-md-block">Upload Records</span>
                      <i class="fa fa-close d-none d-xs-block d-sm-block d-md-block d-lg-none"></i>
                    </button>
                  </h5>
                </div>
              </div>
              <div class="panel-body">
                <div class="row">
                  <div class="col-md-12" style="width: 100%;">
                    <table id="table1" class="dataTable table table-striped1">
                      <thead>
                        <tr>
                          <th></th>
                          <th [appSort]="ViewFTERecordsList" data-order="desc" data-name="FTEID" style="cursor: pointer;">Record ID</th>
                          <th [appSort]="ViewFTERecordsList" data-order="desc" data-name="EmpName" style="cursor: pointer;">Employee Name</th>
                          <th>Service Line</th>
                          <th>Market Segment</th>
                          <th>Title</th>
                          <th>Location</th>
                          <th [appSort]="ViewFTERecordsList" data-order="desc" data-name="EmpContractEndDate" style="cursor: pointer;">Contract End Date</th>
                          <th>Counsellor</th>
                          <th>Manager</th>
                          <th>Partner</th>
                          <th>Status</th>
                          <th>Engagement Code</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of ViewFTERecordsList; let i = index;">
                          <td>
                            <input type="checkbox" name="item{{item.ID}}" [(ngModel)]="ViewFTERecordsList[i].checked">
                          </td>
                          <td *ngIf="this.ParamID == 6">
                            {{item.FTEID}}
                          </td>
                          <td *ngIf="this.ParamID != 6">
                            <a (click)="onFTERecordClick(item.IDEncrypt)" style="cursor: pointer;">{{item.FTEID}}</a>
                          </td>
                          <td>{{item.EmpName}} ({{item.EmpEmail}})</td>
                          <td>{{item.SL}}</td>
                          <td>{{item.EmpMarketSegment}}</td>
                          <td>{{item.EmpTitle}}</td>
                          <td>{{item.EmpLocation}}</td>
                          <td>{{item.EmpContractEndDate}}</td>
                          <td>{{item.CouncelorName}}</td>
                          <td>{{item.ManagerName}}</td>
                          <td>{{item.PartnerName}}</td>
                          <td>{{item.RequestStatusDesc}}</td>
                          <td>{{item.EngCode}}</td>
                        </tr>
                        <tr *ngIf="ViewFTERecordsList==null || ViewFTERecordsList.length==0">
                          <td colspan="15" style="text-align: center;color: red;">Record not found.</td>
                        </tr>
                      </tbody>
                    </table>
                    <ul class="pagination" *ngIf='(ViewFTERecordsList?.length||0)>0'>
                      <li class="page-item">
                        <button class="page-link" (click)="firstPage()"
                                *ngIf="FTERecordsList.currentPage > 1">
                          First
                        </button>
                      </li>
                      <li class="page-item">
                        <button class="page-link" (click)="PreviousPage()" *ngIf="FTERecordsList.currentPage > 1">
                        </button>
                      </li>
                      <li *ngFor="let n of range(FTERecordsList.TotalPageCount)" class="page-item">
                        <button class="page-link" (click)="setPage(n+1)" [innerHtml]="n+1">{{n+1}}</button>
                      </li>
                      <li class="page-item" *ngIf="FTERecordsList.currentPage < FTERecordsList.TotalPageCount">
                        <!-- || FTERecordsList.TopRecord >= FTERecordsList.TotalRecord -->
                        <button class="page-link" (click)="NextPage()">>></button>
                      </li>
                      <li class="page-item" *ngIf="FTERecordsList.currentPage < FTERecordsList.TotalPageCount">
                        <!-- || FTERecordsList.TopRecord >= FTERecordsList.TotalRecord -->
                        <button class="page-link" (click)="lastPage()">Last</button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
